export default {
  invoices: null,
  loading: false,
  showWindow: false
}